module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS1.2b94e19c.jpg";